import { DOCUMENT, inject, Injectable } from '@angular/core';

import { UrlService } from 'src/services/url/url.service';

import { DEFAULT_SETTINGS, PAGE_SCHEMAS } from './entities/const';
import type { SpeculationRulesSchema } from './entities/types';

@Injectable({
    providedIn: 'root',
})
export class SpeculationRulesService {
    private document = inject<Document>(DOCUMENT);
    private readonly urlService = inject(UrlService);

    public init() {
        this.initScript('default-speculation-rules', DEFAULT_SETTINGS);
        this.initScript('specific-speculation-rules', this.generateSchemaForSpecificPage());
    }

    private initScript(id: string, schema: SpeculationRulesSchema) {
        if (!this.document.getElementById(id) && schema) {
            const script = this.document.createElement('script');
            script.type = 'speculationrules';
            script.id = id;

            script.textContent = JSON.stringify(schema);

            this.document.head.appendChild(script);
        }
    }

    private generateSchemaForSpecificPage(): SpeculationRulesSchema | null {
        const currentPage = PAGE_SCHEMAS.find((setting) => setting.page === this.urlService.getPathnameOutsideRouter());

        if (currentPage) {
            return currentPage.schema;
        }

        return null;
    }
}
